import React from 'react';
// import sections
import HelpContent from '../components/sections/HelpContent';

const Help = () => {
  return (
    <>
      <HelpContent />
    </>
  );
};

export default Help;
